import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)`
    padding: 40px;
    min-width: 460px;
`;
export const StyledButtonContainer = styled(Box)`
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
`;
export const StyledScheduledModeBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
